var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "slide-pages",
      attrs: { tabindex: "0" },
      on: {
        keydown: _vm.key,
        wheel: function ($event) {
          if (!$event.ctrlKey) return null
          $event.preventDefault()
          return _vm.scale($event.deltaY < 0 ? 0.25 : -0.25)
        },
      },
    },
    [
      _vm.state.phase === "ready"
        ? _c("div", { staticClass: "slide-controls" }, [
            _c("span", [_vm._v("服务器分页预览")]),
            _c(
              "button",
              {
                attrs: { disabled: _vm.state.index <= 1 },
                on: {
                  click: function ($event) {
                    return _vm.go(_vm.state.index - 1)
                  },
                },
              },
              [_vm._v("上一页")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.jump,
                  expression: "jump",
                },
              ],
              attrs: {
                type: "number",
                min: 1,
                max: _vm.state.pages,
                "aria-label": "跳转页码",
              },
              domProps: { value: _vm.jump },
              on: {
                change: _vm.jumpTo,
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.stopPropagation()
                  return _vm.jumpTo.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.jump = $event.target.value
                },
              },
            }),
            _c("span", [_vm._v("/ " + _vm._s(_vm.state.pages))]),
            _c(
              "button",
              {
                attrs: { disabled: _vm.state.index >= _vm.state.pages },
                on: {
                  click: function ($event) {
                    return _vm.go(_vm.state.index + 1)
                  },
                },
              },
              [_vm._v("下一页")]
            ),
            _c(
              "button",
              {
                attrs: { "aria-label": "缩小预览" },
                on: {
                  click: function ($event) {
                    return _vm.scale(-0.25)
                  },
                },
              },
              [_vm._v("−")]
            ),
            _c("output", [_vm._v(_vm._s(Math.round(_vm.zoom * 100)) + "%")]),
            _c(
              "button",
              {
                attrs: { "aria-label": "放大预览" },
                on: {
                  click: function ($event) {
                    return _vm.scale(0.25)
                  },
                },
              },
              [_vm._v("＋")]
            ),
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    _vm.zoom = 1
                    _vm.session.quality("screen")
                  },
                },
              },
              [_vm._v("适应宽度")]
            ),
          ])
        : _vm._e(),
      _vm.state.error
        ? _c("div", { staticClass: "slide-status", attrs: { role: "alert" } }, [
            _vm._v(_vm._s(_vm.state.error) + " "),
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    return _vm.session.retry()
                  },
                },
              },
              [_vm._v("重试预览")]
            ),
          ])
        : _vm.state.phase !== "ready" || _vm.state.busy
        ? _c(
            "div",
            { staticClass: "slide-status", attrs: { role: "status" } },
            [
              _vm._v(
                _vm._s(
                  _vm.state.phase === "ready"
                    ? "正在加载当前页…"
                    : _vm.state.message
                )
              ),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "slide-image" }, [
        _vm.state.src
          ? _c("img", {
              style: { width: _vm.zoom * 100 + "%" },
              attrs: { src: _vm.state.src, alt: "PPT当前页" },
              on: { error: _vm.imageError },
            })
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }